export default {
  // 操作バー
  addAssign: 'コード割り当てを追加',
  // 検索
  batchNo: 'バッチ番号',
  batchNoPlaceholder: 'バッチ番号を入力してください',
  codeSn: 'QRコード',
  codeSnPlaceholder: 'QRコードを入力してください',
  productName: '製品名',
  productNamePlaceholder: '製品名を入力してください',
  productSn: '製品番号',
  productSnPlaceholder: '製品番号を入力してください',
  productionBatch: '生産バッチ',
  productionBatchPlaceholder: '生産バッチを入力してください',
  // テーブル列
  colProductInfo: '製品情報',
  colProductionBatch: '生産バッチ',
  colBatchNo: 'バッチ番号',
  colQrcodeRange: 'QRコード範囲',
  colCount: '数量',
  colRemark: '備考',
  colCreatedAt: '作成日時',
  colOperator: '操作者',
  colAction: '操作',
  // 製品情報
  productNo: '製品番号',
  // 生産バッチ
  batchId: 'ID',
  // 操作
  delete: '削除',
  // コード割り当て追加モーダル
  addAssignTitle: '製品コード割り当てを追加',
  batchNoLabel: 'バッチ番号',
  selectBatch: '選択',
  rangeType: '範囲タイプ',
  rangeTypeAll: '全バッチ関連',
  rangeTypeRange: '範囲関連',
  assignType: 'コード割り当て方式',
  assignTypeProduct: '製品別',
  assignTypeProductionBatch: '生産バッチ別',
  startQrcode: '開始QRコード',
  endQrcode: '終了QRコード',
  relatedProduct: '関連製品',
  selectProduct: '製品を選択',
  remarkLabel: '備考',
  remarkPlaceholder: '備考を入力してください',
  batchNoRequired: 'バッチを選択してください',
  productRequired: '製品を選択してください',
  productionBatchRequired: '生産バッチを選択してください',
  selectProductionBatch: '選択',
  startQrcodeRequired: '開始QRコードを入力してください',
  endQrcodeRequired: '終了QRコードを入力してください',
  // 削除確認
  deleteConfirmTitle: '削除の確認',
  deleteConfirmContent: 'このコード割り当て記録を削除しますか？',
  // 空状態
  emptyText: 'コード割り当て記録がありません',
};
